import React from "react";
import { Home } from "./page";
import "./App.scss";

function App() {
  return (
    <div>
      <Home />
    </div>
  );
}

export default App;
